export const STATUS_PENDING = 'pending';
export const STATUS_WITHDRAWN = 'withdrawn';
export const STATUS_CONFIRMED = 'confirmed';
export const STATUS_REJECTED = 'rejected';
export const STATUS_FINISHED = 'finished';